import "./ContactsPage.css";
import Cover from "../../components/Cover/Cover";
import coverImage from "../../assets/images/mainCoverImage.webp";
import coverImageMobile from "../../assets/images/mainCoverImageMobile.webp";
import contactIcon1 from "../../assets/icons/contactIcon1.png";
import contactIcon2 from "../../assets/icons/contactIcon2.png";
import contactIcon3 from "../../assets/icons/contactIcon3.png";

const ContactsPage = () => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;

  return (
    <div className="page">
      <title>Контакти — ТОВ «Миколаївмолпром» | Виробник молочної продукції Pastoral</title>
<meta name="description" content="Зв’яжіться з ТОВ «Миколаївмолпром» — виробником натуральної молочної продукції під ТМ «Pastoral» та «Мумуля». Наші контакти: смт Доманівка, вул. Пастера, 31/1, тел. +38(066) 444-55-33, e-mail: officemanager.dmsz@gmail.com."/>

      <Cover src={coverImageToUse} text={"“Pastoral” -  Французькі традиції"} />
      <div className="contects__wrapper">
        <div className="contects__wrapper-cards">
        <div className="contects__wrapper-item-card">
            <img
              src={contactIcon1}
              alt="іконка контакта"
              className="contects__wrapper-item-card-icon"
            />
            <p className="contects__wrapper-item-card-text int-r-21">
              СМТ Доманівка
            </p>
            <p className="contects__wrapper-item-card-text int-r-21">
              вул. Пастера, 31/1
            </p>
          </div>
          <div className="contects__wrapper-item-card">
            <img
              src={contactIcon2}
              alt="іконка контакта"
              className="contects__wrapper-item-card-icon"
            />
            <a className="contects__wrapper-item-card-text int-r-21" href="tel:+380664445533">+38(066) 444-55-33</a>
            <a className="contects__wrapper-item-card-text int-r-21" href="mailto:officemanager.dmsz@gmail.com">officemanager.dmsz@gmail.com</a>
          </div>
          <div className="contects__wrapper-item-card">
            <img
              src={contactIcon3}
              alt="іконка контакта"
              className="contects__wrapper-item-card-icon"
            />
            <p className="contects__wrapper-item-card-text int-r-21">
            7:00-17:00
            </p>
            <p className="contects__wrapper-item-card-text int-r-21">
            Без вихідних
            </p>
          </div>
        </div>
        <div className="contects__wrapper-items">
          {" "}
         
        <div className="contects__wrapper-item">
       
          <h3 className="contects__wrapper-item-subtitle mont-m">
          місто Миколаїв
          </h3>
          <a className="contects__wrapper-item-card-text int-r-21" href="tel:+380952799941">+38(095) 279-99-41</a>
          <p className="contects__wrapper-item-text int-r-21">
          Пн - пт 7.00 - 19.00
<br /> Сб - нд 8.00 - 18.00
            </p>
            <p className="contects__wrapper-item-text int-r-21">
            Проспект Центральний, 114/1
            </p>
            <p className="contects__wrapper-item-text int-r-21">
            вул. Спаська, 50Б
            </p>
            <p className="contects__wrapper-item-text int-r-21">
            вул. Театральна, 39
            </p>
        </div>
        <div className="contects__wrapper-item">
          {" "}
          
          <h3 className="contects__wrapper-item-subtitle mont-m">
          СМТ Доманівка
          </h3>
          <a className="contects__wrapper-item-card-text int-r-21" href="tel:+380952799941">+38(095) 279-99-41</a>
          <p className="contects__wrapper-item-text int-r-21">
          Пн - пт 7.30 - 19.00
          <br /> Сб - вс 8.00 - 18.00
            </p>
            <p className="contects__wrapper-item-text int-r-21">
            вул. Пастера, 33/1
            </p>
        </div>
      </div>
    </div>
    </div>

  );
};

export default ContactsPage;
